import type { RouteLocationNamedRaw, RouteLocationNormalizedLoaded } from 'vue-router'

export type LibrarySubKey = 'checklist' | 'templates'
export type CareTemplateTab = 'essential' | 'enhanced' | 'premium'

const SUB_ROUTE_NAMES: Record<LibrarySubKey, string> = {
  checklist: 'LibraryChecklistItems',
  templates: 'LibraryCareTemplates',
}

const ROUTE_NAME_TO_SUB: Partial<Record<string, LibrarySubKey>> = {
  LibraryChecklistItems: 'checklist',
  LibraryCareTemplates: 'templates',
}

export function librarySubKeyFromRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'name'>,
): LibrarySubKey | null {
  const name = route.name ? String(route.name) : ''
  return ROUTE_NAME_TO_SUB[name] ?? null
}

export function libraryListRouteForSub(key: LibrarySubKey): RouteLocationNamedRaw {
  return { name: SUB_ROUTE_NAMES[key] }
}

export function techniciansRoute(): RouteLocationNamedRaw {
  return { name: 'Technicians' }
}

export function careTemplatesRoute(tab?: CareTemplateTab): RouteLocationNamedRaw {
  if (!tab) return { name: 'LibraryCareTemplates' }
  return { name: 'LibraryCareTemplates', query: { tab } }
}

export function careTemplateTabFromRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'name' | 'query'>,
): CareTemplateTab {
  if (route.name !== 'LibraryCareTemplates') return 'essential'
  const tab = typeof route.query.tab === 'string' ? route.query.tab : ''
  if (tab === 'enhanced' || tab === 'premium') return tab
  return 'essential'
}

export function isTechniciansRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'name'>,
): boolean {
  return route.name === 'Technicians'
}
